import React, { useEffect, useState, useContext } from 'react';
import { classIf, getConfiguration, getMatchIdOrStageId, iconSportCssClass } from '../../data/utils';
import MainContext from '../../contexts/MainContext';
import { WidgetContext, brWidgetS5Enabled, bgWidgetEnabled, statsCoreWidgetEnabled, STATSCORE_WIDGET_LIVESCORE, getFlashbetWidgetUrl, getBetgeniustWidgetUrl } from '../../data/widgets/WidgetContext';
import ButtonsContainer from './ButtonsContainer';
import MatchBet from '../../common/MatchBet';
import FlashbetWidget from '../../data/widgets/FlashbetWidget';
import BetGeniusWidget from '../../data/widgets/BetGeniusWidget';
import StatsCoreWidget from '../../data/widgets/StatsCoreWidget';
import MessageInfo from '../../common/MessageInfo';
import { getLabel } from '../../InitData';
import ExpandCollapse from '../../common/ExpandCollapse';
import GoUpParag from '../../common/GoUpParag';
import { xs_languageCode } from '../..';
import StatsToggle from '../../common/StatsToggle';

function BetBuilderMatch(props) {
	const conf = getConfiguration();
	const betBuilderMatch = props.betBuilderMatch;
	const betsData = props.betsData;
	const aggregates = betsData.gruppiScommessa;
	
	const [selectedAggregate, selectAggregate] = useState(aggregates[0].idAggregata);
	
    const aggregateBtns = aggregates.map(function(betGroup, i) {
        function handleClick() {
            selectAggregate(betGroup.idAggregata);
        }
        const selected = betGroup.idAggregata === selectedAggregate;

        return (
            <div key={i} className={"bg-bianco nero bordo-tondo elemento-macro pointer filter" + classIf(selected, 'icona-selezionata agg-selezionata')} onClick={handleClick}>{betGroup.descrizione}</div>
        );
    });
    const agg = betsData.gruppoById[selectedAggregate];
    const aggMarkets = {};
    let compMapIds = null;
    if(selectedAggregate > 0){
    	if(agg.compattate){
    		compMapIds = {};
    		for(let kc in agg.compattate){
    			let index = 1;
    			const compactedMarket = agg.compattate[kc];
    			for(let ks in compactedMarket){
    				const originalBetId = compactedMarket[ks];
    				const handicap = originalBetId.split("_")[1];
    				const compactedIdMarket = `cmp_${selectedAggregate}_${index}_${handicap}`;
    				let localizedDescription = ks;
    				if(agg.localeCmpDesc && agg.localeCmpDesc[ks] && agg.localeCmpDesc[ks][xs_languageCode]){
    					localizedDescription = agg.localeCmpDesc[ks][xs_languageCode];
    				}
    				compMapIds[originalBetId] = {
    					compactedIdMarket,
    					desc : localizedDescription
    				};
    			}
    				index ++;
    		}
    	}
        for(let ks in agg.scommesse){
        	let key = [agg.scommesse[ks].id, agg.scommesse[ks].handicap].join("_");
        	if(compMapIds && compMapIds[key]){
    			key = compMapIds[key].compactedIdMarket;
    		}
    		aggMarkets[key] = true;
    	}
    }

    
    
    let bets = betsData.bets.filter((bet) => {
    	if(bet.hasOdds === true){
    		if(selectedAggregate < 0){
    			return true;
    		}
    		/*const toDebug = bet.id + "";
    		if(toDebug.indexOf("cmp_") >= 0) {
    			//debugger;
    		}*/
    		
    		
    		let key = [bet.id, bet.handicap].join("_");
    		if(aggMarkets[key]){
    			return true;
    		}
    		if(bet.handicap != 0){
    			key = [bet.id, 0].join("_");
    			return aggMarkets[key];
    		}
    	}
    	return false;	   	
    });

    
    const mainContext = useContext(MainContext);
    const widgetContext = useContext(WidgetContext);
    const isBrWidgetS5 = brWidgetS5Enabled(betBuilderMatch.sportRef, betBuilderMatch.widgetType);
    const isBetgeniusWidget = bgWidgetEnabled(betBuilderMatch.sportRef, betBuilderMatch.widgetType, betBuilderMatch.geniusId);
    const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType, betBuilderMatch.lsportWidgetId);
    const flashbetWidgetUrl = getFlashbetWidgetUrl(betBuilderMatch.widgetType);
    
    
    useEffect(function() {
        if (!betBuilderMatch.isLive) {
            widgetContext.setWidget({
                widgetMatchId: getMatchIdOrStageId(betBuilderMatch),
                widgetLsportId: betBuilderMatch.lsportWidgetId,
                widgetProviderType: betBuilderMatch.widgetType,
                widgetContainerId: '#collassaWidgetCompetition',
                widgetStartCollapsed: true
            });
        }

        return function() {
            if(conf.lstwc){
                mainContext.setStreamingContainer('betradar-widget');
            }else{
                mainContext.toggleStreaming(null,null,null);

            }
            const settings = {
                isWidgetToggleable: true
            };
            if (!betBuilderMatch.isLiveSuite) {
                Object.assign(settings, {
                    widgetMatchId: null,
                    widgetLsportId: null,
                    widgetProviderType: null
                });
            }
            widgetContext.setWidget(settings);
        };
    }, [betBuilderMatch.isLive, betBuilderMatch.id]);

    const icoSport = iconSportCssClass(betBuilderMatch.sportRef, betBuilderMatch.iconClass);
    
    return <>
		<div className="titolo-blocco-sport bg-nero bianco">
	        <div className="d-flex justify-content-between align-items-center w-100" >
	            {betBuilderMatch.isLive &&
	                <div className={`img-fluid ico-sport mr-1 ${icoSport}`}></div>
	            }
	            <p className="nome-partita-sport"> {getLabel('betbuilder.match_header')} {betBuilderMatch.team1} - {betBuilderMatch.team2}</p>
	            <p className="data-orario-partita-sport d-flex justify-content-end align-items-center margine-sx">
	                {betBuilderMatch.date} {betBuilderMatch.time}
                    <StatsToggle className="fas fa-chart-bar stat-sel margine-sx-mezzo grigio pointer" match={betBuilderMatch} />
	            </p>
	        </div>
    	</div>
    	{widgetContext.widgetMatchId != null &&  widgetContext.widgetContainerId==='#collassaWidgetCompetition' &&
			<div className={`widget-filtro-side margine-giu live-tracker-widget ${isBetgeniusWidget?'betgeniusWidget':''}`}>
                {flashbetWidgetUrl ?
                    <FlashbetWidget url={flashbetWidgetUrl}/>
                    :
                    isBetgeniusWidget ?
                        <BetGeniusWidget url={getBetgeniustWidgetUrl(betBuilderMatch.sportRef, betBuilderMatch.categoryRef, betBuilderMatch.tournamentRef)} />
                    :
                    isStatsCoreWidget ?
                        <StatsCoreWidget />
                    :
                    <div className={`bordato-widget bg-nero ${isBrWidgetS5?'brWidgetS5':''} `} id="collassaWidgetCompetition"></div>
                }
			</div>
		 }
         {betBuilderMatch.giocabilita !== undefined && !betBuilderMatch.giocabilita?
         	<MessageInfo message={getLabel('general.giocabilita_chiusa')} />
            :
            <>
                {(aggregates && aggregateBtns.length > 1) &&
                    <div className="macro-gruppi">
                    	<ButtonsContainer id={selectedAggregate} buttons={aggregateBtns} aggregate={true} forceRows={false} maxNumOfRows={2} />
                    </div>
                }
                <ExpandCollapse key={selectedAggregate} />
                <div className="colonne-evento-live d-grid unaColonna">
                    {
	                    (bets.map(function(bet) {
                            const id = `${bet.id}_${bet.handicap}`;
                            return (
                                <MatchBet key={id} {...bet} sportRef={betBuilderMatch.sportRef} expanded={true} betBuilder={true} />
                            );
                        }))
                    }
                </div>
                <GoUpParag/>
            </>
            }
    </>
}
            
export default BetBuilderMatch;